module.exports = __webpack_public_path__ + "img/9788957982693.be640bc0.jpg";